<app-demo [datasource]="datasource" [context]="demoContext" [sources]="sources">
  <div description>
    <p>
      The <em>padding</em> setting defines an extra space out of the visible
      part of the viewport that should be filled with items. This provides
      outlets that determine when the items are to be created/destroyed. See
      also the
      <a href="https://github.com/dhilt/vscroll/wiki/Viewport">Viewport doc</a>
      for details.
    </p>
    <p>
      The value is relative to the visible size of the viewport. So
      <em>1.46</em> means that the Scroller would request new items until the
      areas of 146% of the viewport size in both forward and backward directions
      are filled with rendered items: 100% + 146% downward and 146% upward. In
      this demo we have 3 requests on the initial load, let's see what happened:
    </p>
    <ol>
      <li>
        250px + 1.46 * 250px = 615px &mdash; total size of area that needs to be
        filled in downward (positive) direction, where 250px is the size of the
        visible viewport (per CSS)
      </li>
      <li>
        7 items * 25px = 175px &mdash; the result size of the first downward
        fetch, where <em>bufferSize</em> is 7 and 25px is the item's size (per
        CSS)
      </li>
      <li>
        615px - 175px = 440px &mdash; downward space which has to be filled
        during the second downward fetch
      </li>
      <li>
        ceil(440px / 25px) = 18 &mdash; the number of items that should fill
        440px area during the second downward fetch
      </li>
    </ol>
    <p>
      So we have 2 <em>Datasource.get</em> downward requests for 7 and 18 items.
      And this is an explanation of the last (initial backward) fetch:
    </p>
    <ol>
      <li>
        1.46 * 250px = 360px &mdash; upward space that has to be filled in
        backward (negative) direction
      </li>
      <li>
        ceil(360px / 25px) = 15 &mdash; the number of items that should fill
        360px during backward fetch
      </li>
    </ol>
    <p>
      This way we got 40 DOM elements (7 + 18 + 15 = 40). The bigger
      <em>padding</em> value is, the more DOM elements should be present in the
      viewport.
    </p>
    <p>
      The default value of <em>padding</em> property is 0.5. It is a floating
      point number. The minimum value is 0.01.
    </p>
  </div>
</app-demo>
